import { useParams } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import NotFoundPage from './NotFoundPage.jsx';
import { getRaceBySlug, formatRaceDateLong } from '../lib/content.js';

const DEFAULT_HEADER = '/images/default_trail_header-heading.jpg';

function InfoRow({ label, children }) {
  return (
    <div className="row">
      <div className="col-5 race-info-head">{label}</div>
      <div className="col-7 race-info-text">{children}</div>
    </div>
  );
}

/** Single race (single-race.php). */
export default function RacePage() {
  const { slug } = useParams();
  const race = getRaceBySlug(slug);

  if (!race) return <NotFoundPage />;

  const header = race.headerImage || DEFAULT_HEADER;

  return (
    <>
      <div
        className="page-banner"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${header})`,
        }}
      >
        <div className="row" style={{ height: '100%' }}>
          <div className="col-1"></div>
          <div className="col-10 page-banner-textarea">
            <div className="row page-banner-heading-text">{race.title}</div>
            <div className="row page-banner-tagline-text">{race.tagline}</div>
          </div>
          <div className="col-1"></div>
        </div>
      </div>

      <div className="container-fluid page-textarea">
        <div className="row">
          <div className="col-2"></div>
          <div className="col-4">
            <div className="row">
              <div className="col race-info-head text-center">
                <u>Info</u>
              </div>
            </div>
            <InfoRow label="Race Date:">{formatRaceDateLong(race.date)}</InfoRow>
            <InfoRow label="Race Distance:">{race.distance}</InfoRow>
            <InfoRow label="Race Location:">{race.location}</InfoRow>
          </div>
          <div className="col-4">
            <div className="row">
              <div className="col race-info-head text-center">
                <u>Results</u>
              </div>
            </div>
            <InfoRow label="Time:">{race.time}</InfoRow>
            <InfoRow label="Place:">{race.place}</InfoRow>
            <InfoRow label="Pace:">{race.pace}</InfoRow>
            <InfoRow label="Recap Blog:">
              {race.blogLink ? <a href={race.blogLink}>Here</a> : null}
            </InfoRow>
          </div>
          <div className="col-2"></div>
        </div>
        {race.websiteLink && (
          <div className="row">
            <div className="col-2"></div>
            <div className="col-8">
              <div className="row">
                <div className="col race-info-text text-center">
                  <u>
                    <a href={race.websiteLink} target="_blank" rel="noreferrer">
                      Race Website
                    </a>
                  </u>
                </div>
              </div>
            </div>
            <div className="col-2"></div>
          </div>
        )}
        {race.content && (
          <div className="row">
            <div className="col-2"></div>
            <div
              className="col-8 page-text"
              dangerouslySetInnerHTML={{ __html: race.content }}
            ></div>
            <div className="col-2"></div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}
